package repdb

import com.ustadmobile.door.DoorDatabaseJdbc
import com.ustadmobile.door.DoorPrimaryKeyManager
import com.ustadmobile.door.ext.doorDatabaseMetadata
import com.ustadmobile.door.ext.mutableLinkedListOf
import com.ustadmobile.door.ext.nodeIdAuthCache
import com.ustadmobile.door.ext.rootDatabase
import com.ustadmobile.door.jdbc.DataSource
import com.ustadmobile.door.log.DoorLogger
import com.ustadmobile.door.room.InvalidationTracker
import com.ustadmobile.door.room.RoomDatabase
import com.ustadmobile.door.room.RoomDatabaseJdbcImplHelper
import com.ustadmobile.door.room.RoomJdbcImpl
import com.ustadmobile.door.util.NodeIdAuthCache
import com.ustadmobile.door.util.systemTimeInMillis
import kotlin.IllegalStateException
import kotlin.Int
import kotlin.String
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.toTypedArray

public class RepDb_JdbcImpl(
  override val doorJdbcSourceDatabase: RoomDatabase?,
  override val dataSource: DataSource,
  dbUrl: String,
  override val dbName: String,
  override val jdbcQueryTimeout: Int,
  jdbcDbType: Int,
  logger: DoorLogger,
) : RepDb(), DoorDatabaseJdbc, RoomJdbcImpl {
  override val dbVersion: Int
    get() = 1

  override val jdbcImplHelper: RoomDatabaseJdbcImplHelper = RoomDatabaseJdbcImplHelper(
        dataSource = dataSource,
        db = this,
        dbUrl = dbUrl,
        dbName = dbName,
        logger = logger,
        tableNames = this::class.doorDatabaseMetadata().allTables,
        invalidationTracker =
            InvalidationTracker(*this::class.doorDatabaseMetadata().allTables.toTypedArray()),
        dbType = jdbcDbType,
      )


  override val realNodeIdAuthCache: NodeIdAuthCache by lazy {
        if(this == rootDatabase) {
          val nodeIdAuthCache = NodeIdAuthCache(this)
          nodeIdAuthCache
        } else {
          rootDatabase.nodeIdAuthCache
        }
      }


  override val realPrimaryKeyManager: DoorPrimaryKeyManager by lazy {
        DoorPrimaryKeyManager(RepDb::class.doorDatabaseMetadata().replicateEntities.keys)
      }


  override val invalidationTracker: InvalidationTracker
    get() = jdbcImplHelper.invalidationTracker

  public val _RepDao: RepDao_JdbcImpl by lazy { RepDao_JdbcImpl(this) }

  override val repDao: RepDao
    get() = _RepDao

  public val _CompositePkDao: CompositePkDao_JdbcImpl by lazy { CompositePkDao_JdbcImpl(this) }

  override val compositePkDao: CompositePkDao
    get() = _CompositePkDao

  public val _RepWithAttachmentDao: RepWithAttachmentDao_JdbcImpl by
      lazy { RepWithAttachmentDao_JdbcImpl(this) }

  override val repWithAttachmentDao: RepWithAttachmentDao
    get() = _RepWithAttachmentDao

  override fun createAllTables(): List<String> {
    val _stmtList = mutableLinkedListOf<String>()
    when(jdbcImplHelper.dbType) {
      1 ->  {
        // - create for this SQLite 
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS _doorwayinfo (dbVersion int primary key, dbHash varchar(255))"
         _stmtList += "INSERT INTO _doorwayinfo VALUES (1, '')"
        //Begin: Create table RepEntity for SQLite
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE RepEntity RENAME to RepEntity_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS RepEntity (  reLastChangedBy  INTEGER  NOT NULL , reLastChangeTime  INTEGER  NOT NULL  DEFAULT 0 , reNumField  INTEGER  NOT NULL , reString  TEXT , reBoolean  INTEGER  NOT NULL , rePrimaryKey  INTEGER  PRIMARY KEY  AUTOINCREMENT  NOT NULL )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO RepEntity (reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean, rePrimaryKey) SELECT reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean, rePrimaryKey FROM RepEntity_OLD")
        _stmt.executeUpdate("DROP TABLE RepEntity_OLD")
        END MIGRATION*/
        //End: Create table RepEntity for SQLite

        //Begin: Create table DoorNode for SQLite
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE DoorNode RENAME to DoorNode_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS DoorNode (  auth  TEXT , nodeId  INTEGER  NOT NULL , rel  INTEGER  NOT NULL  DEFAULT 2 , PRIMARY KEY (nodeId) )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO DoorNode (auth, nodeId, rel) SELECT auth, nodeId, rel FROM DoorNode_OLD")
        _stmt.executeUpdate("DROP TABLE DoorNode_OLD")
        END MIGRATION*/
        //End: Create table DoorNode for SQLite

        //Begin: Create table RepEntityWithAttachment for SQLite
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE RepEntityWithAttachment RENAME to RepEntityWithAttachment_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS RepEntityWithAttachment (  waVersionId  INTEGER  NOT NULL , waAttachmentUri  TEXT , waMd5  TEXT , waSize  INTEGER  NOT NULL , waUid  INTEGER  PRIMARY KEY  AUTOINCREMENT  NOT NULL )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO RepEntityWithAttachment (waVersionId, waAttachmentUri, waMd5, waSize, waUid) SELECT waVersionId, waAttachmentUri, waMd5, waSize, waUid FROM RepEntityWithAttachment_OLD")
        _stmt.executeUpdate("DROP TABLE RepEntityWithAttachment_OLD")
        END MIGRATION*/
        //End: Create table RepEntityWithAttachment for SQLite

        //Begin: Create table SyncNode for SQLite
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE SyncNode RENAME to SyncNode_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS SyncNode (  nodeClientId  INTEGER  NOT NULL , PRIMARY KEY (nodeClientId) )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO SyncNode (nodeClientId) SELECT nodeClientId FROM SyncNode_OLD")
        _stmt.executeUpdate("DROP TABLE SyncNode_OLD")
        END MIGRATION*/
        //End: Create table SyncNode for SQLite

        //Begin: Create table CompositePkEntity for SQLite
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE CompositePkEntity RENAME to CompositePkEntity_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS CompositePkEntity (  code1  INTEGER  NOT NULL , code2  INTEGER  NOT NULL , name  TEXT , PRIMARY KEY (code1, code2) )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO CompositePkEntity (code1, code2, name) SELECT code1, code2, name FROM CompositePkEntity_OLD")
        _stmt.executeUpdate("DROP TABLE CompositePkEntity_OLD")
        END MIGRATION*/
        //End: Create table CompositePkEntity for SQLite

        //Begin: Create table OutgoingReplication for SQLite
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE OutgoingReplication RENAME to OutgoingReplication_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS OutgoingReplication (  destNodeId  INTEGER  NOT NULL , orPk1  INTEGER  NOT NULL , orPk2  INTEGER  NOT NULL  DEFAULT 0 , orPk3  INTEGER  NOT NULL  DEFAULT 0 , orPk4  INTEGER  NOT NULL  DEFAULT 0 , orTableId  INTEGER  NOT NULL , orUid  INTEGER  PRIMARY KEY  AUTOINCREMENT  NOT NULL )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO OutgoingReplication (destNodeId, orPk1, orPk2, orPk3, orPk4, orTableId, orUid) SELECT destNodeId, orPk1, orPk2, orPk3, orPk4, orTableId, orUid FROM OutgoingReplication_OLD")
        _stmt.executeUpdate("DROP TABLE OutgoingReplication_OLD")
        END MIGRATION*/
        //End: Create table OutgoingReplication for SQLite

      }
      2 ->  {
        // - create for this PostgreSQL 
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS _doorwayinfo (dbVersion int primary key, dbHash varchar(255))"
         _stmtList += "INSERT INTO _doorwayinfo VALUES (1, '')"
        //Begin: Create table RepEntity for PostgreSQL
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE RepEntity RENAME to RepEntity_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS RepEntity (  reLastChangedBy  BIGINT  NOT NULL , reLastChangeTime  BIGINT  NOT NULL  DEFAULT 0 , reNumField  INTEGER  NOT NULL , reString  TEXT , reBoolean  BOOL  NOT NULL , rePrimaryKey  BIGSERIAL  PRIMARY KEY  NOT NULL )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO RepEntity (reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean, rePrimaryKey) SELECT reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean, rePrimaryKey FROM RepEntity_OLD")
        _stmt.executeUpdate("DROP TABLE RepEntity_OLD")
        END MIGRATION*/
        //End: Create table RepEntity for PostgreSQL

        //Begin: Create table DoorNode for PostgreSQL
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE DoorNode RENAME to DoorNode_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS DoorNode (  auth  TEXT , nodeId  BIGINT  NOT NULL , rel  INTEGER  NOT NULL  DEFAULT 2 , PRIMARY KEY (nodeId) )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO DoorNode (auth, nodeId, rel) SELECT auth, nodeId, rel FROM DoorNode_OLD")
        _stmt.executeUpdate("DROP TABLE DoorNode_OLD")
        END MIGRATION*/
        //End: Create table DoorNode for PostgreSQL

        //Begin: Create table RepEntityWithAttachment for PostgreSQL
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE RepEntityWithAttachment RENAME to RepEntityWithAttachment_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS RepEntityWithAttachment (  waVersionId  BIGINT  NOT NULL , waAttachmentUri  TEXT , waMd5  TEXT , waSize  INTEGER  NOT NULL , waUid  BIGSERIAL  PRIMARY KEY  NOT NULL )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO RepEntityWithAttachment (waVersionId, waAttachmentUri, waMd5, waSize, waUid) SELECT waVersionId, waAttachmentUri, waMd5, waSize, waUid FROM RepEntityWithAttachment_OLD")
        _stmt.executeUpdate("DROP TABLE RepEntityWithAttachment_OLD")
        END MIGRATION*/
        //End: Create table RepEntityWithAttachment for PostgreSQL

        //Begin: Create table SyncNode for PostgreSQL
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE SyncNode RENAME to SyncNode_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS SyncNode (  nodeClientId  BIGINT  NOT NULL , PRIMARY KEY (nodeClientId) )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO SyncNode (nodeClientId) SELECT nodeClientId FROM SyncNode_OLD")
        _stmt.executeUpdate("DROP TABLE SyncNode_OLD")
        END MIGRATION*/
        //End: Create table SyncNode for PostgreSQL

        //Begin: Create table CompositePkEntity for PostgreSQL
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE CompositePkEntity RENAME to CompositePkEntity_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS CompositePkEntity (  code1  BIGINT  NOT NULL , code2  BIGINT  NOT NULL , name  TEXT , PRIMARY KEY (code1, code2) )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO CompositePkEntity (code1, code2, name) SELECT code1, code2, name FROM CompositePkEntity_OLD")
        _stmt.executeUpdate("DROP TABLE CompositePkEntity_OLD")
        END MIGRATION*/
        //End: Create table CompositePkEntity for PostgreSQL

        //Begin: Create table OutgoingReplication for PostgreSQL
        /* START MIGRATION: 
        _stmt.executeUpdate("ALTER TABLE OutgoingReplication RENAME to OutgoingReplication_OLD")
        END MIGRATION */
        _stmtList +=
            "CREATE TABLE IF NOT EXISTS OutgoingReplication (  destNodeId  BIGINT  NOT NULL , orPk1  BIGINT  NOT NULL , orPk2  BIGINT  NOT NULL  DEFAULT 0 , orPk3  BIGINT  NOT NULL  DEFAULT 0 , orPk4  BIGINT  NOT NULL  DEFAULT 0 , orTableId  INTEGER  NOT NULL , orUid  BIGSERIAL  PRIMARY KEY  NOT NULL )"
        /* START MIGRATION: 
        _stmt.executeUpdate("INSERT INTO OutgoingReplication (destNodeId, orPk1, orPk2, orPk3, orPk4, orTableId, orUid) SELECT destNodeId, orPk1, orPk2, orPk3, orPk4, orTableId, orUid FROM OutgoingReplication_OLD")
        _stmt.executeUpdate("DROP TABLE OutgoingReplication_OLD")
        END MIGRATION*/
        //End: Create table OutgoingReplication for PostgreSQL

      }
    }
    return _stmtList
  }

  public fun makeClearAllTablesSql(): List<String> {
    val _stmtList = mutableListOf<String>()
    _stmtList += "DELETE FROM RepEntity"
    _stmtList += "DELETE FROM DoorNode"
    _stmtList += "DELETE FROM RepEntityWithAttachment"
    _stmtList += "DELETE FROM SyncNode"
    _stmtList += "DELETE FROM CompositePkEntity"
    _stmtList += "DELETE FROM OutgoingReplication"
    return _stmtList
  }

  override fun clearAllTables(): Unit = throw
      IllegalStateException("clearAllTables synchronous not supported on Javascript")

  override suspend fun clearAllTablesAsync() {
    execSQLBatchAsyncJs(*makeClearAllTablesSql().toTypedArray())
  }

  override fun close() {
    jdbcImplHelper.close()
  }
}
